<script>
import Layout from '@layouts/main'
import api from '@utils/api'

export default {
  name: 'Setting',
  components: { Layout },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    currentItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      item: {
        name: null,
        value: null,
      },
      rules: {
        isRequired: [x => !!x || this.$t('validation__is_required')],
        empty: [() => true],
      },
    }
  },
  watch: {
    currentItem: {
      handler(next) {
        Object.assign(this.item, next)
      },
      deep: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
      this.$refs.formNew.reset()
    },
    submit() {
      if (this.$refs.formNew.validate()) {
        this.loading = true
        api.updateGlobalSetting(this.item).then(response => {
          this.$emit('item-updated')
          this.$emit('close-modal')
          this.loading = false
          this.$refs.formNew.reset()
        })
      }
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px">
    <v-card>
      <v-card-title class="headline text-xs-center">
        <v-spacer />
        {{ $t(`titles__update`) }}
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-form
                ref="formNew"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                  :label="$t('label__name')"
                  :rules="rules.isRequired"
                  :value="$t('label__'+item.name)"
                  name="name"
                  readonly
                />
                <v-text-field
                  :label="$t('label__value')"
                  v-model = "item.value"
                  :rules="rules.isRequired"
                  name="value"
                  required
                />
              </v-form>
            </v-flex>
            <small>* {{ $t('label__requier_small_text') }}</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="success"
          @click="submit">{{ $t('buttons__update') }}
        </v-btn>
        <v-btn
          color="secondary"
          @click="closeModal">
          {{ $t('buttons__close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
